import Toggle from './toggle';

export type { ToggleProps, ToggleRef } from './toggle';
export default Toggle;
